<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_alert_setting') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="updatealertsetting()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__row">
      <gs-field :label="$t('frontend_groovemail_admin_alert_setting_spam_threshold')">
        <div class="gm-admin-tab__suffix">
          <text-input
            variant="base"
            v-model="model.spam_threshold"
            :placeholder="this.$t('frontend_groovemail_admin_alert_setting_spam_threshold')"
            :validator="$v.model.spam_threshold"
          />
          <span>%</span>
        </div>
      </gs-field>
      <gs-field :label="$t('frontend_groovemail_admin_alert_setting_bounce_threshold')">
        <div class="gm-admin-tab__suffix">
          <text-input
            variant="base"
            v-model="model.bounced_threshold"
            :placeholder="this.$t('frontend_groovemail_admin_alert_setting_bounce_threshold')"
            :validator="$v.model.bounced_threshold"
          />
          <span>%</span>
        </div>
      </gs-field>
      <gs-field :label="$t('frontend_groovemail_admin_alert_setting_threshold_time')">
        <text-input
          variant="base"
          v-model="model.waiting_threshold"
          :placeholder="this.$t('frontend_groovemail_admin_alert_setting_threshold_time')"
          :validator="$v.model.waiting_threshold"
        />
      </gs-field>
    </div>

    <div class="gm-admin-tab__stack gm-admin-form gm-admin-tab__stack--spaced">
      <gs-field
        :label="$t('frontend_groovemail_admin_alert_setting_emails')"
        :hint="$t('frontend_groovemail_admin_block_emails_note')"
      >
        <text-area
          variant="base"
          :validator="$v.model.notification_emails"
          v-model="model.notification_emails"
          :placeholder="this.$t('frontend_groovemail_admin_alert_setting_emails')"
        />
        <input type="hidden" v-model="model.id"
          value="model.id" />
      </gs-field>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, numeric,between,decimal } from 'vuelidate/lib/validators';
import AlertsSetting from '@/models/AlertsSetting';
import Swal from 'sweetalert2';
import themeConfig from '@/theme/themeConfig';

export default {
  data() {
    return {
      model: {
        spam_threshold: '',
        bounced_threshold: '',
        waiting_threshold: '',
        notification_emails: '',
      },
    };
  },
  validations: {
    model: {
      spam_threshold: {
        required,
        decimal,
        between: between(0, 100),
      },
      bounced_threshold: {
       required,
       decimal,
        between: between(0, 100),
      },
      waiting_threshold: {
        required,
        decimal,
      },  
      notification_emails: {
        required,
      },
    },
  },

  async created() {
    await this.initializeAlertSettingData();
  },

  methods: {
    async initializeAlertSettingData() {
      this.$emit('showLoader');
      this.settings = await AlertsSetting.$get();
      this.model.spam_threshold = this.settings[0].spam_threshold
        ? this.settings[0].spam_threshold
        : 0;
      this.model.bounced_threshold = this.settings[0].bounced_threshold
        ? this.settings[0].bounced_threshold
        : 0;
      this.model.waiting_threshold = this.settings[0].waiting_threshold;
      this.model.notification_emails = this.settings[0].notification_emails;
      this.model.id = this.settings[0].id
        ? this.settings[0].id
        : 0;
      this.$emit('hideLoader');
    },

    async updatealertsetting() {
      let validity = true;

      this.$v.model.spam_threshold.$touch();
      this.$v.model.bounced_threshold.$touch();
      this.$v.model.waiting_threshold.$touch();
      this.$v.model.notification_emails.$touch();
      validity = !(
        this.$v.model.spam_threshold.$invalid ||
        this.$v.model.bounced_threshold.$invalid ||
        this.$v.model.waiting_threshold.$invalid ||
        this.$v.model.notification_emails.$invalid
      );

      if (validity) {
        const confirmEdit = await Swal.fire({
          html: `
            <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
            <p class="text-lg font-bold text-danger mb-3"> Please type CONFIRM to confirm your changes</p>
          `,
          title: this.$t('frontend_groovemail_admin_spam_alert_sertting_update_confirm'),
          input: 'text',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonColor: '#2f80ed',
          cancelButtonColor: themeConfig.appPrimaryColor,
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Confirm',
          inputValidator: (value) => {
            if (value !== 'CONFIRM') {
              return 'Please enter correct message to confirm your changes';
            }
          },
        });
        if (
          confirmEdit.dismiss === Swal.DismissReason.cancel ||
          confirmEdit.dismiss === Swal.DismissReason.close
        ) {
          return false;
        } else {
            this.$emit('showLoader');
            const res = await axios.post('alertsetting/update', {
            id : this.model.id,
            spam_threshold: this.model.spam_threshold,
            bounced_threshold: this.model.bounced_threshold,
            waiting_threshold: this.model.waiting_threshold,
            notification_emails: this.model.notification_emails,
          });
          this.$emit('hideLoader');
      }
      }
    },
  },
};
</script>


<style lang="scss">
.swal2-title {
  font-size: 20px;
  font-weight: 600;
}
</style>
